<template>
  <div :class="`alert-container alert-${type}${customClass.length > 0 ? ` ${customClass}` : ''}`" role="alert">
    <p class="alert">
      <span class="alert-icon mr-0" aria-hidden="true"></span>
      <span :class="`ob1-alert-title${!maxWidth ? ' no-max-width' : ''}`">{{ title }}</span>
    </p>
    <div v-if="subtitle" class="alert-content">
      <p class="alert-text">{{ subtitle }}</p>
    </div>
    <div v-else-if="button" class="alert-content">
      <button @click="action" class="btn btn-secondary" type="button">{{ button }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: null,
    },
    button: {
      type: String,
      required: false,
      default: null,
    },
    action: {
      type: Function,
      required: false,
      default: () => {return}
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['info', 'success', 'warning', 'danger'].includes(value)
      }
    },
    maxWidth: {
      type: Boolean,
      required: false,
      default: true,
    },
    customClass: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-info,
.alert-success,
.alert-warning,
.alert-danger {
  max-width: 780px;
  .alert-content button {
    background-color: transparent;
  }
  .alert-icon:before {
    background-image: unset;
  }
  .ob1-alert-title {
    &.no-max-width {
      max-width: unset;
    }
  }
}
</style>